import React, { useEffect, useState } from 'react'
import useUserPosts from 'sdk/hooks/user/useUserPosts';
import Page from 'modules/app/components/Page';
import PostList from 'components/shared/PostList/PostList'
import useGetAllTradingPlatforms from 'sdk/hooks/trading/useGetAllTradingPlatforms';
import { useParams } from 'react-router-dom';

export default function TradingPage() {
  const { id } = useParams()
  const { data: trades, isLoading } = useGetAllTradingPlatforms()
  const tradesPostsIds = trades ? trades.map((p) => p.post_id) : []
  const { data: posts, isFetching: tradePostsLoading, refetch } = useUserPosts(tradesPostsIds)
  const [mappedPosts, setMappedPosts] = useState<unknown>([])

  useEffect(() => {
    document.body.classList.add('overflow-hidden');

    return () => {
      document.body.classList.remove('overflow-hidden');
    }
  })

  useEffect(() => {
    if (posts) {
      const mapped = posts.map((p) => {
        const trade = trades?.find((t) => t.post_id === p.id)
        if (trade) {
          return { ...p, tradingPlatform: trade }
        }
        return p
      })
      const currentIndex = mapped.findIndex((p) => p.id === id)
      let mappedFromCurrent: any[] | null = null;
      if (id && currentIndex !== -1) {
        mappedFromCurrent = [
          ...mapped.slice(currentIndex, mapped.length),
          ...mapped.slice(0, currentIndex),
        ]
      }
      setMappedPosts(mappedFromCurrent ?? mapped)
    }
  }, [posts])

  return (
    <Page activeLink="/liked">
      <PostList posts={mappedPosts} refetch={refetch} isLoading={tradePostsLoading || isLoading} />
    </Page>
  )
}
